import React from 'react';
import { ClassAssembly1A2025 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly1A2025/>;
  };
  
  export default ClassAssemblyPage;